<template>
	<Container>
		<Title>
			{{ $t('Delegations') }}
		</Title>
		<div>
			<div class="w-full flex justify-end">
				<div class="lg:w-1/3 flex lg:mr-3 mb-4"></div>
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
			<ListTable
				:itemsTitles="itemsTitles"
				:items="organizations_delegations"
				:itemsTable="itemsTable"
				:section="section"
			/>
		</div>
	</Container>
</template>

<script>
import ListTable from '@/components/ListTable'
import { fetchDelegations } from '@/apollo/delegations'

export default {
	apollo: {
		organizations_delegations: fetchDelegations()
	},
	data() {
		return {
			section: 'delegacion',
			itemsTable: 'organizations_delegations',
			itemsTitles: [
				'Id',
				'Nombre',
				'Zona',
				'state',
				'Telefono',
				'email',
				'offices'
			]
		}
	},
	components: { ListTable }
}
</script>
